import React from 'react';

function Loader() {
  return (
    <div className="loader-body hidden">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
